import { render, staticRenderFns } from "./user-withdraw.vue?vue&type=template&id=40c73e76"
import script from "./user-withdraw.vue?vue&type=script&lang=js"
export * from "./user-withdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports